$( document ).ready(function() {
    $(document).on('click', '.footer__block--menu h4, .footer__block--text h4 ', function() {
      if($(window).width() <769){
        if($(this).parent().hasClass('active')){
          $(this).parent().removeClass('active');
        }else{
          $(this).parent().addClass('active');
        }
      }
    });
    $(document).on('click', '.view-description, .scroll-to-section', function(event) {
      var targetSelector = $(this).attr('href');
      var target = targetSelector && targetSelector.charAt(0) === '#' ? $(targetSelector) : $();

      if (!target.length && $(this).hasClass('view-description')) {
        target = $(".shopify-section--tabs");
      }

      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 120
        }, 800);
      }
    });

    $(document).on('click', '.icon-shiping', function() {
    if($(".shipping-delivery").attr("aria-expanded") == "false"){
      $(".shipping-delivery .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".shipping-delivery").offset().top - 200
    }, 800);
  });
  $(document).on('click', '.icon-warranty', function() {
    if($(".warranty").attr("aria-expanded") == "false"){
      $(".warranty .accordion__toggle").trigger("click");
    }
    $('html, body').animate({
        scrollTop: $(".warranty").offset().top - 200
    }, 800);
  });
  $(document).on('click', '.icon-return', function() {
    if($(".yearly-monthly").attr("aria-expanded") == "false"){
      $(".yearly-monthly .accordion__toggle").trigger("click");
    }
    $('html, body').animate({
        scrollTop: $(".yearly-monthly").offset().top - 200
    }, 800);
  });
});
$(window).on('load', function() {
  
  $(document).on('click', '.op-more-1', function() {
    if($(".professional").attr("aria-expanded") == "false"){
      $(".professional .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".professional").offset().top - 200
    }, 800);
  });
  $(document).on('click', '.op-more-2', function() {
    if($(".yearly-monthly").attr("aria-expanded") == "false"){
      $(".yearly-monthly .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".yearly-monthly").offset().top - 200
    }, 800);
  });
  $(document).on('click', '.op-more-3', function() {
    if($(".detection-pendant").attr("aria-expanded") == "false"){
      $(".detection-pendant .accordion__toggle").trigger("click");
    }
    $('html, body').animate({
        scrollTop: $(".detection-pendant").offset().top - 200
    }, 800);
  });
  $(document).on('click', '.variant-card__wrapper .radio-option', function() {
    $(this).parent().parent().click();
  });
  
});
function openImpactAccordion() {
  document
    .querySelectorAll('.cart-line-item-option')
    .forEach((item) => {
      item.open = true;
    });
}

document.addEventListener('DOMContentLoaded', openImpactAccordion);

document.addEventListener('shopify:section:load', openImpactAccordion);

setTimeout(openImpactAccordion, 500);
document.addEventListener('DOMContentLoaded', () => {
  var monitoringType = "";
  var planType = "";
  var familyfriendsCheck = "";
  $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
    if($(this).find(".variant-card__title").text().trim() == 'Family & friends monitoring'){
      familyfriendsCheck = $(this).find(".variant-card__title").text().trim();
    }
  });
  
  if($('.variant-card__price').length){
    const variantPicker = document.querySelector('variant-picker')

    const variant = JSON.parse(
      variantPicker.querySelector('[data-variant]').textContent
    );
    

    if(familyfriendsCheck == 'Family & friends monitoring'){
      $('.variant-card__price').hide();
      $('.price_family_value').show();
      $('.option-subtitle').hide();
      $('.option-subtitle-family').show();
    }else{
      $('.variant-card__price').show();
      $('.price_family_value').hide();
      $('.option-subtitle').show();
      $('.option-subtitle-family').hide();
    }
  }

  
  $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
      if(index == 0){
        monitoringType = $(this).find(".variant-card__title").text().trim();
      }else if(index == 1){
        var planPrice = $(this).find(".variant-card__price:visible").text().trim();
        if(planPrice == "$0.00"){
          planPrice = "BYO SIM";
        }
        planType = $(this).find(".variant-card__title .op-title").text().trim();
        console.log(planType);
        if(planType == "Pay yearly"){
          planType = "/year ";
        }else if(planType == "Pay monthly"){
          planType = "/month ";
        }else if(planType == "Pay quarterly"){
          planType = "/quarter ";
        }else{
          planType = " ";
        }
        $(".monitoring-plan").html(monitoringType +": "+planPrice + planType);
      }else if(index == 2){
         if($(this).find(".variant-card__price:visible").text().trim() != "$0"){
            $(".fall-dectection").html(" + Fall dectection: "+$(this).find(".variant-card__price:visible").html());
         }else{
            $(".fall-dectection").html("");
         }
      }
  });
      
});

let isFixing = false;
let lockedPosition = null;

// 1. LISTEN CHANGE
document.addEventListener('change', (e) => {

  if (!e.target.matches('[data-option-position]')) return;

  // 🔒 lock option user vừa click
  lockedPosition = parseInt(e.target.dataset.optionPosition);

  if (isFixing) return;
  var familyfriendsCheck = "";
  $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
    if($(this).find(".variant-card__title").text().trim() == 'Family & friends monitoring'){
      familyfriendsCheck = $(this).find(".variant-card__title").text().trim();
    }
  });

var monitoringType = "";
  var planType = "";
  setTimeout(async () => {

    const variantJson = document.querySelector(
      'variant-picker [data-variant]'
    )?.textContent;

    const currentVariant = variantJson
      ? JSON.parse(variantJson)
      : null;

    // nếu variant hợp lệ → không làm gì
    if (currentVariant !== null){
      if(familyfriendsCheck == 'Family & friends monitoring'){
        $('.variant-card__price').hide();
        $('.price_family_value').show();
        $('.option-subtitle').hide();
        $('.option-subtitle-family').show();
      }else{
        $('.variant-card__price').show();
        $('.price_family_value').hide();
        $('.option-subtitle').show();
        $('.option-subtitle-family').hide();
      }

      $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
          if(index == 0){
            monitoringType = $(this).find(".variant-card__title").text().trim();
          }else if(index == 1){
            var planPrice = $(this).find(".variant-card__price:visible").text().trim();
            if(planPrice == "$0.00"){
              planPrice = "BYO SIM";
            }
            planType = $(this).find(".variant-card__title .op-title").text().trim();
            if(planType == "Pay yearly"){
              planType = "/year ";
            }else if(planType == "Pay monthly"){
              planType = "/month ";
            }else if(planType == "Pay quarterly"){
              planType = "/quarter ";
            }else{
              planType = " ";
            }
            $(".monitoring-plan").html(monitoringType +": "+planPrice + planType);
          }else if(index == 2){
            if($(this).find(".variant-card__price:visible").text().trim() != "$0"){
                $(".fall-dectection").html(" + Fall dectection: "+$(this).find(".variant-card__price:visible").html());
            }else{
                $(".fall-dectection").html("");
            }
          }
      });
      return;
    }else{
      $( "input.radio-option" ).each(function( index ) {
        if ($(this).is(':checked')) {
          if ($(this).hasClass('radio-is-disabled')) {
            $(this).parent().find('.is-enableb').first().click();
            setTimeout(function(){ 
              $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
                
                  if(index == 0){
                    monitoringType = $(this).find(".variant-card__title").text().trim();
                  }else if(index == 1){
                    var planPrice = $(this).find(".variant-card__price:visible").text().trim();
                    if(planPrice == "$0.00"){
                      planPrice = "BYO SIM";
                    }
                    planType = $(this).find(".variant-card__title .op-title").text().trim();
                    if(planType == "Pay yearly"){
                      planType = "/year ";
                    }else if(planType == "Pay monthly"){
                      planType = "/month ";
                    }else if(planType == "Pay quarterly"){
                      planType = "/quarter ";
                    }else{
                      planType = " ";
                    }
                    $(".monitoring-plan").html(monitoringType +": "+planPrice + planType);
                  }else if(index == 2){
                    if($(this).find(".variant-card__price:visible").text().trim() != "$0"){
                        $(".fall-dectection").html(" + Fall dectection: "+$(this).find(".variant-card__price:visible").html());
                    }else{
                        $(".fall-dectection").html("");
                    }
                  }
              });
            }, 2500);
              
          }
        }
      });

      $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
          if(index == 0){
            monitoringType = $(this).find(".variant-card__title").text().trim();
          }else if(index == 1){
            var planPrice = $(this).find(".variant-card__price:visible").text().trim();
            if(planPrice == "$0.00"){
              planPrice = "BYO SIM";
            }
            planType = $(this).find(".variant-card__title .op-title").text().trim();
            if(planType == "Pay yearly"){
              planType = "/year ";
            }else if(planType == "Pay monthly"){
              planType = "/month ";
            }else if(planType == "Pay quarterly"){
              planType = "/quarter ";
            }else{
              planType = " ";
            }
            $(".monitoring-plan").html(monitoringType +": "+planPrice + planType);
          }else if(index == 2){
            if($(this).find(".variant-card__price:visible").text().trim() != "$0"){
                $(".fall-dectection").html(" + Fall dectection: "+$(this).find(".variant-card__price:visible").html());
            }else{
                $(".fall-dectection").html("");
            }
          }
      });
    } 

    

    setTimeout(() => {
      const variantPicker = document.querySelector('variant-picker')

    const variant = JSON.parse(
      variantPicker.querySelector('[data-variant]').textContent
    )

  if(familyfriendsCheck == 'Family & friends monitoring'){
      $('.variant-card__price').hide();
        $('.price_family_value').show();
        $('.option-subtitle').hide();
        $('.option-subtitle-family').show();
      }else{
        $('.variant-card__price').show();
        $('.price_family_value').hide();
        $('.option-subtitle').show();
        $('.option-subtitle-family').hide();
      }
    }, 100);

  }, 80);
  $( ".variant-card.is-enableb.option-checked" ).each(function( index ) {
      if(index == 0){
        monitoringType = $(this).find(".variant-card__title").text().trim();
      }else if(index == 1){
        var planPrice = $(this).find(".variant-card__price:visible").text().trim();
        if(planPrice == "$0.00"){
          planPrice = "BYO SIM";
        }
        planType = $(this).find(".variant-card__title .op-title").text().trim();
        if(planType == "Pay yearly"){
          planType = "/year ";
        }else if(planType == "Pay monthly"){
          planType = "/month ";
        }else if(planType == "Pay quarterly"){
          planType = "/quarter ";
        }else{
          planType = " ";
        }
        $(".monitoring-plan").html(monitoringType +": "+planPrice + planType);
      }else if(index == 2){
         if($(this).find(".variant-card__price:visible").text().trim() != "$0"){
            $(".fall-dectection").html(" + Fall dectection: "+$(this).find(".variant-card__price:visible").html());
         }else{
            $(".fall-dectection").html("");
         }
      }
  });
  
});


// 3. GET CURRENT SELECTED OPTIONS
function getSelectedOptions() {

  const get = (pos) => {
    const checked = document.querySelector(
      `[data-option-position="${pos}"]:checked`
    );

    if (!checked) return null;

    const label = document.querySelector(
      `label[for="${checked.id}"]`
    );

    return label ? label.innerText.trim() : null;
  };

  return {
    option1: get(1),
    option2: get(2),
    option3: get(3),
  };
}


// 4. APPLY VARIANT (LOCK MODE)
function applyLockedVariant(variant) {

  // 🔒 KHÔNG được override option user vừa click
  if (lockedPosition !== 1) {
    clickOption(1, variant.option1);
  }

  if (lockedPosition !== 2) {
    clickOption(2, variant.option2);
  }

  if (lockedPosition !== 3) {
    clickOption(3, variant.option3);
  }
}


// 5. CLICK OPTION BY TEXT
function clickOption(position, text) {

  if (!text) return;

  const fieldset = document.querySelectorAll(
    'variant-picker fieldset'
  )[position - 1];

  if (!fieldset) return;

  const labels = [...fieldset.querySelectorAll('label')];

  const label = labels.find(el =>
    el.innerText.includes(text)
  );

  if (label) label.click();
}
